import React, { FunctionComponent } from 'react';
import { StyleProp, StyleSheet, Text, TextStyle } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  header: string;
  style?: StyleProp<TextStyle>;
}

export const BookingInstructionHeader: FunctionComponent<IProps> = ({ header, style }) => (
  <Text style={[styles.header, style]}>{header}</Text>
);

export const BookingInstructionSubtitle: FunctionComponent<IProps> = ({ header, style }) => (
  <Text style={[styles.subTitle, style]}>{header}</Text>
);

const styles = StyleSheet.create({
  header: {
    ...Theme.textStyle.heading,
    paddingBottom: defaultScale(20),
    textAlign: 'center',
    color: Theme.GREY_DARK,
  },
  subTitle: {
    ...Theme.textStyle.bodyCopyReg,
    paddingTop: defaultScale(20),
    textAlign: 'center',
    color: Theme.GREY_DARK_MEDIUM,
  },
});
